//custom code
import "./custom/mobile-menu";
import "./custom/scroller";
import "./custom/torus-animations";
import "./custom/search";
// import './custom/menu-search';
// import './custom/cookie';
import "./custom/splide";
import "./custom/faq";
import "./custom/menu-pill";
import "./custom/vacature-filter";
import "./custom/vacature-hover";

//libraries
import "./lib/fslightbox";
